import React, {useContext} from "react";
import {Form, Radio, Row, Col} from "antd";
import {Title} from "./Common";
import MapPropsContext from "../MapPropsContext";
import {chunksForArray} from "../../../utils";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";

import CheckboxGroupWithJointCheckAll from "./CheckboxGroupWithJointCheckAll";
import Seperator from "./Seperator";


const OPTIONS_FRQ = [
  {band_code: "VLF",  label: "VLF"},
  {band_code: "MF",  label: "MF"},
  {band_code: "HF",  label: "HF"},
  {band_code: "VHF",  label: "VHF"},
  {band_code: "UHF",  label: "UHF"},
  {band_code: "SHF",  label: "SHF"},
  {band_code: "EHF",  label: "EHF"},
];

// const OPTIONS_CLS = [
//   {cls_code: "44",   label: "국종44"},
//   {cls_code: "94",  label: "국종94"},
//   {cls_code: "32",   label: "국종32"},
// ];

const OPTIONS_CLS = [
  {cls_code: "32", label: "기지국"},
  {cls_code: "85", label: "이동중계국"},
  {cls_code: "94", label: "간이무선국"},
  {cls_code: "44", label: "육상이동국"},
  {cls_code: "49", label: "이동국"},
  {cls_code: "92", label: "아마추어국"},
  {cls_code: "42", label: "의무선박국"},
  {cls_code: "41", label: "선박국"},
  {cls_code: "21", label: "고정국"},
  {cls_code: "35", label: "육상국"},
  {cls_code: "11", label: "지상파방송국"},
  {cls_code: "12", label: "실용화시험국(방송국용)"},
  {cls_code: "13", label: "위성방송국"},
  {cls_code: "15", label: "신고제외무선국"},
  {cls_code: "16", label: "지상파방송보조국"},
  {cls_code: "17", label: "발신전용휴대전화(CT-2)"},
  {cls_code: "18", label: "가입자회선용무선국"},
  {cls_code: "19", label: "위성방송보조국"},
  {cls_code: "22", label: "전송망"},
  {cls_code: "23", label: "종합유선방송국"},
  {cls_code: "24", label: "중계유선방송"},
  {cls_code: "25", label: "음악유선방송"},
  {cls_code: "27", label: "개인휴대전화(PCS)"},
  {cls_code: "28", label: "주파수공용무선전화(자가용)"},
  {cls_code: "29", label: "무선조정중계국"},
  {cls_code: "30", label: "무선조정이동국"},
  {cls_code: "31", label: "해안국"},
  {cls_code: "33", label: "항공국"},
  {cls_code: "34", label: "휴대기지국"},
  {cls_code: "36", label: "일반해안국"},
  {cls_code: "37", label: "무선데이타통신"},
  {cls_code: "38", label: "어업용해안국"},
  {cls_code: "40", label: "구명부기국"},
  {cls_code: "43", label: "비상위치지시용무선표지국"},
  {cls_code: "45", label: "항공기국"},
  {cls_code: "46", label: "의무항공기국"},
  {cls_code: "47", label: "휴대국"},
  {cls_code: "48", label: "선상통신국"},
  {cls_code: "50", label: "선박국대여"},
  {cls_code: "51", label: "무선방향탐지국"},
  {cls_code: "52", label: "무선표지국"},
  {cls_code: "53", label: "무선항행육상국"},
  {cls_code: "54", label: "무선항행이동국"},
  {cls_code: "55", label: "무선측위국"},
  {cls_code: "56", label: "무선항행국"},
  {cls_code: "57", label: "무선탐지육상국"},
  {cls_code: "58", label: "무선탐지이동국"},
  {cls_code: "59", label: "비상위치지시용위성무선표지국"},
  {cls_code: "61", label: "비상국"},
  {cls_code: "62", label: "표준주파수및시보국"},
  {cls_code: "63", label: "기상원조국"},
  {cls_code: "64", label: "구내무선국"},
  {cls_code: "65", label: "주파수공용간이무선국"},
  {cls_code: "66", label: "차량디지틀이동전화"},
  {cls_code: "67", label: "휴대디지틀이동전화"},
  {cls_code: "68", label: "차량/휴대디지틀이동전화"},
  {cls_code: "69", label: "위성휴대통신용무선국"},
  {cls_code: "70", label: "육상지구국"},
  {cls_code: "71", label: "우주국"},
  {cls_code: "72", label: "지구국"},
  {cls_code: "73", label: "선박지구국"},
  {cls_code: "74", label: "해안지구국"},
  {cls_code: "75", label: "이동지구국"},
  {cls_code: "76", label: "육상이동지구국"},
  {cls_code: "77", label: "항공지구국"},
  {cls_code: "78", label: "항공기지구국"},
  {cls_code: "79", label: "기지지구국"},
  {cls_code: "80", label: "일반지구국"},
  {cls_code: "81", label: "산업용"},
  {cls_code: "82", label: "통신용"},
  {cls_code: "83", label: "의료용"},
  {cls_code: "84", label: "차량이동가입무선전화"},
  {cls_code: "86", label: "휴대이동가입무선전화"},
  {cls_code: "87", label: "주파수공용무선전화"},
  {cls_code: "88", label: "생활무선국(CB)"},
  {cls_code: "89", label: "차량/휴대가입무선전화"},
  {cls_code: "90", label: "이동품질감시"},
  {cls_code: "91", label: "실험국"},
  {cls_code: "93", label: "실용화시험국(실험국용)"},
  {cls_code: "95", label: "고정수신국"},
  {cls_code: "96", label: "무선호출국"},
  {cls_code: "97", label: "무선조정국"},
  {cls_code: "98", label: "코드레스폰"},
  {cls_code: "99", label: "전파천문국"},
  // {cls_code: "RD", label: "레이다펄스변조송신"},
  // {cls_code: "TV", label: "TV방송국"},
];

// // 지역정보 표시방법, value값은 as-is를 그대로 적용합니다.
// const OPTIONS_DISPLAY = [
//   {display_code: "01",  label: "주파수대역별"},
//   {display_code: "02",  label: "용도별"},
// ];


function WidgetPublicStatStation({ options, iconCodeByCls }) {
  const {widgetState, onChangeWidgetState} = useContext(MapPropsContext);
  const {display_code_stats} = widgetState;

  return (
    <Form.Item>
      {/* <CheckboxGroupWithCheckAll
        title="주파수 대역"
        fieldName={"band_code_stats_list"}
        options={OPTIONS_FRQ.map(({ band_code, label }) => ({
          value: band_code,
          label,
        }))}
        colSpan={8} />

      <Seperator /> */}

      {/* <CheckboxGroupWithCheckAll
        title="국종"
        fieldName={"cls_code_stats_list"}
        options={OPTIONS_CLS.map(({ cls_code, label }) => ({
          value: cls_code,
          label,
        }))}
        colSpan={8} /> */}
        
        <CheckboxGroupWithJointCheckAll
        title="국종"
        fieldName={"cls_code_stats_list"}
        // Todo.option
        // options={options.map(({ cls_code, label }) => ({
        options={OPTIONS_CLS.map(({ cls_code, label }) => ({
          value: cls_code,
          label,
          iconCode: iconCodeByCls[cls_code],
        }))}
        colSpan={12} />


      {/*
      <Seperator />
      <Title>지역정보 표시 방법 선택</Title>
      <Radio.Group name="display_code_stats"
                   value={display_code_stats}
                   style={{width: '100%'}}
                   onChange={onChangeWidgetState}>
        {chunksForArray(OPTIONS_DISPLAY, 2).map((chunk, index) =>
          <Row key={index}>
            {chunk.map(({ display_code, label }) =>
              <Col span={12} key={display_code}>
                <Radio value={display_code} key={display_code}>{label}</Radio>
              </Col>
            )}
          </Row>
        )}
      </Radio.Group> 
      */}

    </Form.Item>
  );
}


export default WidgetPublicStatStation;
